import { render } from "./VtoCatalog.vue?vue&type=template&id=27c77876"
import script from "./VtoCatalog.vue?vue&type=script&lang=js"
export * from "./VtoCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__